import { BasicSelect, MultiSelect } from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';
import Treeselect from '@riophae/vue-treeselect';
import FTCMemoDepositSlip from './../FTCMemoDepositSlip';
import Printd from 'printd'
import TripServices from '../../../services/firstAndLastmilemanagement.service';
import awbextracharges from '../../TripManagement/AddExtraCharges';
import showextracharges from '../../TripManagement/AddExtraCharges/CreateExtraCharges'
const moment = require('moment');

export default {
  name: 'createFTCRADShipment',
  components: {
    Treeselect,
    awbextracharges,
    showextracharges,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    FTCMemoDepositSlip,
    Loader,
  },
  props: ['parentObj'],
  data: function () {
    return {
      showPrintCashMemo: false,
      createFtcRadShipment: false,
      addawbextracharges:false,
      expanded: false,
      isLoading: false,
      accordianTab: { 1: false, 2: false, 3: false ,4:false ,5:false},
      showFTCAmount: false,
      AWB: "",
      NoofMPS: "",
      origincity:'',
      destinationcity:'',
      Error:0,
      errorModal:false,
      pickupdate:'',
      raddate:'',
      consignoraddress1: '',
      consignoraddress2: '',
      consigneeaddress1 : '',
      consigneeaddress2 : '',
      pickuppincode : '',
      destinationpincode:'',
      emailerr:'',
      contacterr:'',
      gst:'',
      pickupstate:'',
      recalenable:0,
      destinationstate:'',
      freightChargesData:{},
      insurancechargesData:{},
      accessorialchargesData:{},
      awbExtraChargesData:{},
      showextracharge:false,
      showCharges:false,
      totalFTCamount: '',
      totalaccessorialCharges: '',
      totalawbextracharges: '',
      totalfreightcharges: '',
      totalinsurancecharges: '',
      useremail:'',
      ftctotalamtwogst:'',
      printAwb:[],
      confirmDisabled:false,
      paymentLinkConfirmation:false,
      finalConsgineeEmail:'',
      finalConsgineeContact:'',
      paymentlinkdisabled:false,
      originname:'',
      destinationname:'',
      Errormessage : [],
      defaultHubId:'',
      FTCAMOUNTLIMIT: 500000
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.defaultHubId = userdetail.hubID
    this.isLoading = true;
    this.defaultHubId = userdetail.hubID
    if(this.parentObj.action == 'calculateFtc' || this.parentObj.action == 'cashMemo'){
      await Promise.all([
        this.getFTCamount(),
        this.getFTCshippingDetails()
      ]);
      if(this.parentObj.action == 'cashMemo') this.clickPrintCashMemo();
    }
    this.isLoading = false;
  },
  methods: {
    openextracharges() {
      this.showextracharge = true;
      // this.addawbextracharges = true;
    },
async closeExtracharge(){
    if(this.totalFTCamount>this.FTCAMOUNTLIMIT)
    {
      this.$alertify.error('Unable to calculate FTC');
    }
      this.showextracharge = false;
      // this.addawbextracharges = false;
        this.isLoading = true;
        await Promise.all([
          this.getFTCamount(),
          this.getFTCshippingDetails()
        ]);
          this.isLoading = false;
    },
    callparent2(){
      this.addawbextracharges = false;
    },
    async getFTCshippingDetails(){
      try {
        this.isLoading = true;
        let payload = {
          awb : this.parentObj.AWB
        }
        let data = await TripServices.GetFTCShipmentDetails(payload);
        if(data.data.code == 200){
          let details = data.data.data;
          this.AWB = details.AWB
          this.NoofMPS = details["MPS Count"]
          this.origincity = details.pickupCity
          this.destinationcity = details.dropCity
          this.pickupdate = moment(details.PickUpDate).tz('Asia/Kolkata').format('DD/MM/YYYY')
          this.raddate = details.RAADDate ? moment(details.RAADDate).tz('Asia/Kolkata').format('DD/MM/YYYY') : null
          this.consignoraddress1 = details.ConsignorName
          this.consignoraddress2 = details.ConsignorAddress
          this.consigneeaddress1 = details.ConsigneeName
          this.consigneeaddress2 = details.ConsigneeAddress
          this.pickuppincode = details.pickupPincode
          this.destinationpincode = details.dropPincode
          this.pickupstate = details.pickupState
          this.destinationstate = details.dropState
          this.congineeEmail = details.ConsigneeEmail;
          this.consigneeContact = details.ConsigneeContactNo;
          this.originname = details.OriginName,
          this.destinationname = details.DestinationName
          this.paymentlinkdisabled = details.paymentdoneflag == 1 ? true : false
          if(details.IsCashMemoGenerated) this.confirmDisabled = true;
        }
        // this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    async getFTCamount(){
      try {
        // this.isLoading = true;
        let payload = {
          awb:this.parentObj.AWB,
          // awb : '94185221110325',
          lastmodifiedby : this.useremail
        }
        let data = await TripServices.getFTCamount(payload);
        if(data.data.code == 200){
          this.Error = 0;
          this.errorModal = false;
          this.Errormessage = [];
          this.freightChargesData = data.data.data.freightCharges;
          this.insurancechargesData = data.data.data.insurancecharge;
          this.accessorialchargesData = data.data.data.accessorialCharges;
          this.awbExtraChargesData = data.data.data.awbextracharges;
          this.totalFTCamount = data.data.data.totalFTCamount;
          this.ftctotalamtwogst = data.data.data.ftctotalamtwogst;
          this.totalaccessorialCharges = data.data.data.totalaccessorialCharges;
          this.totalawbextracharges = data.data.data.totalawbextracharges;
          this.totalfreightcharges = data.data.data.totalfreightcharges;
          this.totalinsurancecharges = data.data.data.totalinsurancecharges;
          this.gst = data.data.data.gst
          this.showCharges = true;
          // if(data.data.data.cashmemodisabledflag) this.confirmDisabled = true;'
          if(this.totalFTCamount>this.FTCAMOUNTLIMIT)
          {
            this.Errormessage.push(`Calculated FTC amount ${this.totalFTCamount} exceeds maximum allowed amount limit . Maximum allowed amount is ${this.FTCAMOUNTLIMIT.toFixed(2)}`)
          }
        }else{
          this.recalenable = 1;
          this.Error = 1
          this.Errormessage=[]
          for(let j=0;j<data.data.message.length;j++)
          {
            this.Errormessage.push(data.data.message[j]);
          }
          this.errorModal = true;
        }
        // this.isLoading = false;
      } catch (err) {
        this.Error = 1
        console.log(err);
        this.isLoading = false;
      }
    },
    async generateCashMemo(){
      try {
        this.showFTCAmount = false;
        this.isLoading = true;
        let payload = {
          awb:this.parentObj.AWB,
          ftcamount : this.totalFTCamount,
          lastmodifiedby: this.useremail
        }
        let data = await TripServices.GenerateCashMemo(payload);
        if(data.data.code == 200){
          this.$alertify.success("FTC amount confirmed successfully. Payment link sent to consignee");
          this.isLoading = false;
          this.confirmDisabled = true;
        }else{
          this.$alertify.error(data.data.message);
        this.isLoading = false;
        }
      } catch (err) {
        this.isLoading = false;
      }
    },
    openPaymentLinkConfirm(){
      this.paymentLinkConfirmation = true;
      this.finalConsgineeEmail = this.congineeEmail;
      this.finalConsgineeContact = this.consigneeContact;
      this.emailerr = '';
      this.contacterr = '';
    },
    validator() {
      let err = 1;
      if (!this.finalConsgineeEmail) {
        this.emailerr = "Please enter email ID";
        err = 0;
      }
      else if (this.finalConsgineeEmail.trim() == '' || this.finalConsgineeEmail.trim() == null || this.finalConsgineeEmail.includes(" ")) {
        this.emailerr = "Please enter a valid email ID";
        err = 0;
      } else {
        this.emailerr = '';
      }
      if (!this.finalConsgineeContact) {
        this.contacterr = "Please enter contact number";
        err = 0
      }
      else if (this.finalConsgineeContact.trim() == '' || this.finalConsgineeContact.trim() == null || this.finalConsgineeContact.includes(" ")) {
        this.contacterr = "Please enter a valid contact number";
        err = 0
      } else if (this.finalConsgineeContact.length > 10 || this.finalConsgineeContact.length < 10) {
        this.contacterr = "The Contact number must be 10 digit"
        err = 0;
      }
      else if (!this.finalConsgineeContact.match(/^[6789]\d{9}$/)) {
        this.contacterr = "The Contact number should start with 6,7,8 or 9"
        err = 0;
      }
      else {
        this.contacterr = '';
      }
      return err;
    },
    async SendFTCPaymentEmail(){
      try {
        if(!this.validator()) return;
        this.isLoading = true;
        let payload = {
          hubid: this.defaultHubId,
          awb : this.parentObj.AWB,
          email : this.finalConsgineeEmail,
          contactNo : this.finalConsgineeContact,
          templatekey : "1"
        }
        let data = await TripServices.SendFTCPaymentEmail(payload);
        if(data.data.code == 200){
          this.$alertify.success("FTC Payment Link Sent");
          this.paymentlinkdisabled = true;
          this.paymentLinkConfirmation = false
        }
        else {
          this.$alertify.error(data.data.message)
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    expandAll() {
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll() {
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid) {
      this.expanded = false;
      for (var key in this.accordianTab) {
        if (tabid != key) {
          this.accordianTab[key] = false;
        }
      }
    },
    clickConfirmAction() {
      if(this.totalFTCamount>this.FTCAMOUNTLIMIT)
      {
        this.recalenable = 1;
        this.errorModal=true
      }
      else{
         this.showFTCAmount = true;
      }
      
    },
    closeconfirmtab() {
      this.showFTCAmount = false;
    },
    async clickPrintCashMemo() {
      this.isLoading = true;
      await this.setMulipleAwbData(this.parentObj.AWB)
      this.showPrintCashMemo = true;
      this.isLoading = false;
    },
    async GetCashMemoData(){
      let payload = {
        // 'awb':"9418522190201"
        awb:this.parentObj.AWB,
      }
      let data = await TripServices.GetCashMemoData(payload)
      return data
    },
    async setMulipleAwbData(){
      this.printAwb=[]
        let data = await this.GetCashMemoData()
        if(data.data.code == 200){
        this.printAwb.push(data.data.data)
        this.printAwb.push(data.data.data)
        }else{
          this.$alert(item.AWB + " - " + data.data.message,"", "error");
        }
    },

    async printCashMemo(){
      try {
        if (this.printAwb.length < 1) {
          this.isLoading = false
          return
        }
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           hr {
                margin-top: 1rem;
                margin-bottom: 1rem;
                border: 1;
                border-top: 1px solid #000;
            }
           table {
               border-collapse: collapse;
               margin-left:3px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          `
          this.$nextTick(() => {
            d.print(document.getElementById('printCashMemoData'), cssText);
          })
    } catch (error) {
      this.isLoading=false
      }
    },
    showCreateFTCShipment() {
      this.$emit("goBackToParent")
    },

  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/FtcRadShipment/createFtcRadShipment/createFtcRadShipment.component.js